/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// utils
import PublishSubscribeUtils from "utils/publish-subscribe-utils/PublishSubscribeUtils.js";

class InteractionUtils {
  static eventListeners = {};
  static topicId = PublishSubscribeUtils.createTopic({ name: "InteractionUtils" });

  /*====================
  eventListeners
  ====================*/
  static _private_addEventListener(eventType) {
    if(!InteractionUtils.eventListeners[eventType]) {
      InteractionUtils.eventListeners[eventType] = (event) => InteractionUtils.publish(event);
      window.addEventListener(eventType, InteractionUtils.eventListeners[eventType], { passive: true });
    }
  }

  static _private_removeEventListener(eventType) {
    if(InteractionUtils.eventListeners[eventType]) {
      window.removeEventListener(eventType, InteractionUtils.eventListeners[eventType]);
      delete(InteractionUtils.eventListeners[eventType]);
    }
  }

  /*====================
  publish & subcribe
  ====================*/
  /**
  * @param {Event} event
  */
   static publish(event) {
    PublishSubscribeUtils.publish(InteractionUtils.topicId, event);
  }

  /**
  * @param {String} eventType
  * @param {Function} onEvent
  * @returns {String}
  */
  static subscribe(eventType, onEvent) {
    InteractionUtils._private_addEventListener(eventType);
    const onEventOverride = (event) => (eventType === event.type) && onEvent(event);
    return PublishSubscribeUtils.subscribe(InteractionUtils.topicId, onEventOverride);
  }

  /**
  * @param {String} subscriberId
  */
  static unsubscribe(subscriberId) {
    PublishSubscribeUtils.unsubscribe(InteractionUtils.topicId, subscriberId);
  }

}
export default InteractionUtils;
